import { SlotParamsService } from '../services/SlotAppParamsService';

const OnlyProdAnnouncements  = {};

export const AnnouncementGames = {
    ...(SlotParamsService.isProd() && OnlyProdAnnouncements),
    'flip-out': {
        name: 'Flip Out',
        first: 'has been discontinued.',
        last: 'Consider trying one of the games below, or see all games to find a new favorite: ',
        games: [
            {
                slug: 'jigsaw',
            },
            {
                slug: 'mahjongg-solitaire',
            },
        ]
    },
    'mahjongg-dimensions-candy': {
        name: 'Mahjongg Dimensions Candy – Try Mahjongg Candy',
        last: 'Consider trying one of the games below, or see all games to find a new favorite: ',
        metaDescription: 'The Mahjongg Dimension Candy game has been discontinued. Try your skills at Mahjongg Dimensions, Mahjongg Dark Dimensions or Mahjongg Candy.',
        games: [
            {
                slug: 'candy-mahjongg',
            },
            {
                slug: 'mahjongg-dimensions',
            },
            {
                slug: 'mahjongg-dark-dimensions',
            },
        ],
        canonical: 'https://games.aarp.org/games/candy-mahjongg'
    },
    'eggz-blast': {
        name: 'Eggz Blast',
        first: 'has been discontinued.',
        last: 'Consider trying one of the games below, or see all games to find a new favorite: ',
        games: [
            {
                slug: 'bubble-dragons',
            },
            {
                slug: 'sweet-shuffle',
            },
            {
                slug: 'alus-revenge-2',
            },
        ]
    },
    'spellbound': {
        name: 'Spellbound',
        first: 'has been discontinued.',
        last: 'Consider trying one of the games below, or see all games to find a new favorite.',
        games: [
            {
                slug: 'word-scramble',
            },
            {
                slug: 'outspell',
            },
            {
                slug: 'word-wipe',
            },
            {
                slug: 'wander-words'
            }
        ]
    },
    'space-hunt': {
        name: 'Spacehunt',
        first: 'has been discontinued.',
        last: 'Consider trying one of the games below, or see all games to find a new favorite: ',
        games: [
            {
                slug: 'sweet-shuffle',
            },
            {
                slug: 'alus-revenge-2',
            },
            {
                slug: 'bubble-dragons',
            }
        ]
    },
};
